import { PropsWithChildren } from 'react';

import styles from './Benefits.module.css';

/** 상품 혜택 영역 */
export const Benefits = ({ children }: PropsWithChildren) => {
  return <div className={styles.wrapper}>{children}</div>;
};
